import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../app/AuthContext';
import axios from 'axios';
import { fromApi } from '../../common/models/asset';

export function useGetSuggestedAssets(userUuid) {
  const { authContext } = useContext(AuthContext);
  const { token } = authContext;
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [suggestedAssets, setSuggestedAssets] = useState({
    matches: [],
    recommended: [],
  });

  useEffect(() => {
    if (!loaded && !loading && userUuid) {
      setLoading(true);
      getSuggestedAssets();
    }
  }, [userUuid, loading, loaded]);

  const getSuggestedAssets = () => {
    axios
      .get(
        `${process.env.REACT_APP_PUBLIC_API_URL}/assets/suggestions/${userUuid}`,
        {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            authorization: `Bearer ${token}`,
          },
        },
      )
      .then(({ data }) => {
        setSuggestedAssets({
          matches: data.matches.map(fromApi),
          recommended: data.recommended.map(fromApi),
        });
        setLoaded(true);
        setLoading(false);
      })
      .catch(err => {
        if (process.env.REACT_APP_VERBOSE === 'true') {
          if (axios.isAxiosError(err))
            console.log(err.response?.status, err.message);
          else console.log(err);
        }
        setLoaded(true);
        setLoading(false);
      });
  };

  return {
    suggestedAssets,
    loading,
  };
}
